import { YesNoItem } from '../typing/yes-no-item';

export const yesNoItems: YesNoItem[] = [
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
  {
    label: 'Unsure',
    value: 'unsure',
  },
];
